import { render, staticRenderFns } from "./DeletePlanDialog.vue?vue&type=template&id=4ac20a4f&"
import script from "./DeletePlanDialog.vue?vue&type=script&lang=js&"
export * from "./DeletePlanDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports